import clsx from 'clsx'
import type { HTMLAttributes, ReactNode } from 'react'

export interface ListToolbarProps extends HTMLAttributes<HTMLDivElement> {
  /** Optional: Überschrift links (z. B. Listenname). */
  title?: string
  /** Optional: Kurzbeschreibung unter der Überschrift. */
  description?: string
  /** Rechte Seite: Suche, Filter, Primäraktion — typ. `input.input-field`, `Button`. */
  trailing?: ReactNode
  /** Optional: Klassen für den trailing-Wrapper (ersetzt/ergänzt z. B. `sm:max-w-xl`). */
  trailingClassName?: string
}

/**
 * Kopfzeile über Listen/Tabellen: Titel links, Steuerung rechts (responsive Wrap).
 * Kinder ohne `trailing` werden wie `trailing` rechts platziert (Kompatibilität).
 */
export function ListToolbar({
  title,
  description,
  trailing,
  trailingClassName,
  children,
  className,
  ...props
}: ListToolbarProps) {
  const controls = trailing ?? children

  return (
    <div
      className={clsx(
        'mb-4 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between',
        className
      )}
      {...props}
    >
      {(title || description) && (
        <div className="min-w-0">
          {title ? (
            <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-50">{title}</h2>
          ) : null}
          {description ? (
            <p className="mt-0.5 text-sm text-gray-600 dark:text-gray-400">{description}</p>
          ) : null}
        </div>
      )}
      {controls ? (
        <div
          className={clsx(
            'flex min-w-0 flex-wrap items-center justify-end gap-2 sm:max-w-xl',
            trailingClassName
          )}
        >
          {controls}
        </div>
      ) : null}
    </div>
  )
}
